import React from "react";

export default function ArmIcon({
  size = 20,
  className,
  ...rest
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      {...rest}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.71253 7.25005L4.30571 12.75H7.00495V7.25005H4.71253Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6928 14.75H8.3072C7.61162 14.75 7.04831 14.3065 7.01187 13.75H4.23176L4.12918 15.1392C4.06479 16.009 4.75189 16.75 5.62244 16.75H14.3773C15.2481 16.75 15.9352 16.009 15.8708 15.1392L15.768 13.75H12.9881C12.9519 14.3138 12.3859 14.75 11.6928 14.75Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.995 7.25V12.75H15.6942L15.2874 7.25H12.995Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.30713 5.25H11.6927C12.3856 5.25 12.9514 5.6955 12.9881 6.25H15.2136L15.0943 4.63925C15.0364 3.856 14.385 3.25 13.601 3.25H6.39907C5.61488 3.25 4.96347 3.856 4.90556 4.63925L4.78651 6.25H7.01179C7.04773 5.6955 7.60181 5.25 8.30713 5.25Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1284 6.25H8.87146C8.38527 6.25 8.00341 6.625 8.00341 7.08325V12.9167C8.00341 13.377 8.39201 13.75 8.87146 13.75H11.1284C11.6059 13.75 11.9967 13.3832 11.9967 12.9167V7.08325C11.9967 6.625 11.6059 6.25 11.1284 6.25Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export const ArmWideIcon = ({ size = 40 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="1">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2801 14.0462H22.4913C23.3531 14.0462 24.0569 14.6046 24.1025 15.2997H26.8708L26.7224 13.2806C26.6504 12.2987 25.8401 11.5391 24.865 11.5391H15.9068C14.9313 11.5391 14.1211 12.2987 14.049 13.2806L13.901 15.2997H16.6689C16.7136 14.6046 17.4028 14.0462 18.2801 14.0462ZM24.1111 23.4479V16.5533H26.9626L27.4686 23.4479H24.1111ZM13.8089 16.5534L13.3029 23.448H16.6604V16.5534H13.8089ZM22.4914 25.955H18.2802C17.415 25.955 16.7143 25.3991 16.669 24.7015H13.2109L13.0833 26.443C13.0032 27.5333 13.8579 28.4621 14.9407 28.4621H25.8306C26.9137 28.4621 27.7684 27.5333 27.6883 26.443L27.5604 24.7015H24.1026C24.0576 25.4082 23.3535 25.955 22.4914 25.955ZM18.9821 15.2997H21.7894C22.3833 15.2997 22.8695 15.7698 22.8695 16.3443V16.5533V23.4479V23.6569C22.8695 24.2417 22.3833 24.7015 21.7894 24.7015H18.9821C18.3857 24.7015 17.9023 24.2339 17.9023 23.6569V23.4479V16.5533V16.3443C17.9023 15.7698 18.3773 15.2997 18.9821 15.2997Z"
          fill="#222222"
        />
      </g>
    </svg>
  );
};
